module.exports = __webpack_public_path__ + "static/media/not-found.ebd53234.png";